import React, { useEffect, useRef, useState } from "react";

import { qrScanner } from "../services/apiController";
import LoaderComponent from "../components/LoaderComponent/LoaderComponent";
import ButtonComponent from "../components/ButtonComponent/ButtonComponent";
import { useNavigate } from "react-router-dom";
import NotificationComponent from "../components/NotificationComponent/NotificationComponent";
import { Scanner } from "@yudiel/react-qr-scanner";

const QRScanner = () => {
    const navigate = useNavigate();

    const [data, setData] = useState("No result");
    const [loading, setLoading] = useState(false);
    const [audioUnlocked, setAudioUnlocked] = useState(false);
    const [scanned, setScanned] = useState(false);
    const [qrSupported, setQrSupported] = useState(true);
    const [supportMessage, setSupportMessage] = useState("");

    const welcomeSound = useRef(new Audio("/sounds/welcomesound.mp3"));
    const errorSound = useRef(new Audio("/sounds/errorsound.mp3"));
    const invalidTicketSound = useRef(new Audio("/sounds/invalidticketsound.mp3"));

    /* Check device QR / Camera support */
    useEffect(() => {
        // wsQRScanner("44unClFMtMdRmT/YH6X6y8coLuzM/lWcFKpL4/oausg=")
        const checkSupport = async () => {
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                setQrSupported(false);
                setSupportMessage("Camera is not supported on this device.");
                return;
            }

            try {
                const devices = await navigator.mediaDevices.enumerateDevices();
                const hasCamera = devices.some(d => d.kind === "videoinput");

                if (!hasCamera) {
                    setQrSupported(false);
                    setSupportMessage("No camera found on this device.");
                }
            } catch (err) {
                setQrSupported(false);
                setSupportMessage("Camera access is blocked or not supported.");
            }
        };

        checkSupport();
    }, []);

    // State to manage snackbar visibility and messages
    const [snackbarStates, setSnackbarStates] = useState({ isSnackbarOpen: false, snackbarMessage: '' });
    const handleCloseSnackbar = () => {
        setSnackbarStates({ isSnackbarOpen: false, snackbarMessage: '', snackbarSeverity: '' });
    };

    /* Stop all sounds */
    const stopAllSounds = () => {
        [welcomeSound, errorSound, invalidTicketSound].forEach(sound => {
            sound.current.pause();
            sound.current.currentTime = 0;
        });
    };

    /* Safe sound play */
    const playSound = (soundRef) => {
        if (!audioUnlocked) return;

        stopAllSounds();

        soundRef.current.play().catch(err => {
            console.log("Audio play blocked:", err);
        });
    };

    /* Unlock audio */
    const unlockAudio = () => {
        // [welcomeSound, errorSound, invalidTicketSound].forEach(sound => {
        //     sound.current.play()
        //         .then(() => {
        //             sound.current.pause();
        //             sound.current.currentTime = 0;
        //         })
        //         .catch(() => { });
        // });

        setAudioUnlocked(true);
    };

    const wsQRScanner = (qrCodeString) => {
        if (!qrCodeString || scanned) return;

        setLoading(true);

        const payload = { qrCode: String(qrCodeString) };

        qrScanner(payload)
            .then((response) => {
                if (response.status === 1) {
                    setScanned(true);
                    playSound(welcomeSound);
                    setData(response.message);
                    setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: response.message, snackbarSeverity: 'success' });
                    setTimeout(() => setScanned(false), 5000);
                } else if (response.status === 2) {
                    setScanned(true);
                    playSound(errorSound);
                    setData(response.message);
                    setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: response.message, snackbarSeverity: 'info' });
                    setTimeout(() => setScanned(false), 5000);
                } else {
                    setAudioUnlocked(false);
                    playSound(invalidTicketSound);
                    setData(response.message);
                    setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: response.message, snackbarSeverity: 'warning' });
                }
            }).catch(() => {
                setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: "Server error", snackbarSeverity: "error" });
            }).finally(() => {
                setLoading(false);
                setTimeout(() => setScanned(false), 5000);
            });
    };


    return loading ? (
        <LoaderComponent />
    ) : (
        <React.Fragment>
            <NotificationComponent isOpen={snackbarStates.isSnackbarOpen} message={snackbarStates.snackbarMessage} onClose={handleCloseSnackbar} severity={snackbarStates.snackbarSeverity} />

            {!qrSupported ?
                (<div style={{ textAlign: "center", marginTop: 40 }}>
                    <h3>QR Scanner Not Supported</h3>
                    <p>{supportMessage}</p>
                </div>)
                : !audioUnlocked ?
                    (<div style={{ textAlign: "center", marginTop: 40 }}>
                        <ButtonComponent onClick={unlockAudio}>Start QR Scanner</ButtonComponent>
                        <p>Tap to enable camera & sound</p>
                    </div>)
                    : !scanned ? (<div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
                        <div style={{ width: 260, height: 260, borderRadius: 12, overflow: "hidden", border: "3px solid #1976d2" }}>
                            <Scanner
                                constraints={{ facingMode: "environment" }}
                                onScan={(result) => {
                                    if (result?.[0]?.rawValue) {
                                        wsQRScanner(result[0].rawValue);
                                    }
                                }}
                                onError={(error) => {
                                    console.log(error);
                                    setScanned(true);
                                    setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: "Camera error", snackbarSeverity: "error", });
                                }}
                                sound={false}
                            />
                        </div>
                    </div>)
                        : (<><p style={{ textAlign: "center", marginTop: 12 }}>{data}</p></>)
            }
        </React.Fragment>
    );
};

export default QRScanner;



{/* <Scanner
                onScan={(detectedCodes) => {
                    if (detectedCodes && detectedCodes.length > 0) {
                        // Display first result
                        setScannedData(detectedCodes[0].rawValue)
                    }
                }}
                onError={(error) => {
                    console.log("");
                }}
                style={{ with: '80%', margin: 'auto' }}
            /> */}

/* Device not supported */
// if (!qrSupported) {
//     return (
//         <div style={{ textAlign: "center", marginTop: 40 }}>
//             <h3>QR Scanner Not Supported</h3>
//             <p>{supportMessage}</p>
//         </div>
//     );
// }

// /* Ask user to start */
// if (!audioUnlocked) {
//     return (
//         <div style={{ textAlign: "center", marginTop: 40 }}>
//             <ButtonComponent onClick={unlockAudio}>
//                 Start QR Scanner
//             </ButtonComponent>
//             <p>Tap to enable camera & sound</p>
//         </div>
//     );
// }